var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import md5 from '../utils/md5';
import * as React from 'react';
var getGravatarUrl = function (email) {
    var hash = md5(email.toLowerCase());
    return "https://s.gravatar.com/avatar/".concat(hash, "?s=128&r=pg&d=404");
};
var getImageSources = function (_a) {
    var src = _a.src, type = _a.type, email = _a.email;
    var sources = {
        primary: src || null,
        fallback: null,
    };
    if (type === 'user' && !!email) {
        sources[sources.primary ? 'fallback' : 'primary'] = getGravatarUrl(email);
    }
    return sources;
};
export var useAvatarImage = function (_a) {
    var src = _a.src, type = _a.type, email = _a.email;
    var _b = __read(React.useState(getImageSources({ src: src, type: type, email: email })), 2), imageSources = _b[0], setImageSources = _b[1];
    var _c = __read(React.useState('primary'), 2), imageToLoad = _c[0], setImageToLoad = _c[1];
    var _d = __read(React.useState('loading'), 2), imageState = _d[0], setImageState = _d[1];
    React.useEffect(function () {
        setImageSources(getImageSources({ src: src, type: type, email: email }));
        setImageToLoad('primary');
        setImageState('loading');
    }, [src, type, email]);
    React.useEffect(function () {
        var imageSrc = imageSources[imageToLoad];
        if (!imageSrc) {
            // set loaded with no image
            setImageState('loaded');
            return undefined;
        }
        setImageState('loading');
        var image = new Image();
        var onLoad = function () { return setImageState('loaded'); };
        var onError = function () {
            if (imageToLoad === 'primary' && !!imageSources.fallback) {
                setImageToLoad('fallback');
            }
            else {
                setImageState('error');
            }
        };
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        image.src = imageSrc;
        return function () {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [imageToLoad, imageSources]);
    return {
        src: imageSources[imageToLoad],
        status: imageState,
    };
};
